module.exports = __webpack_public_path__ + "img/video_yellow.79e06a77.svg";